import { FormGroup } from '@angular/forms';
import { SimulationConstants } from 'src/app/utils/constants/self-serve/simulation.constants';
import { IScoreWeight } from 'src/app/interfaces/self-serve/isimulation-score';

/** Self-authoring's "Skills is weighted but has no rubric" check. Only applies
 * while Skills is switched on with a weight above 0% — at 0% the rubric
 * dropdown is allowed to stay empty. */
export function hasMissingSkillsRubric(form: FormGroup): boolean {
  const sectionWeights = form.get(
    `${SimulationConstants.SCORING_SECTION}.${SimulationConstants.SCORING_WEIGHTS_SECTION}`
  )?.value as IScoreWeight[] | undefined;

  const skills = (sectionWeights ?? []).find(
    (weight) => weight.section === SimulationConstants.SKILLS_SECTION
  );
  if (!skills || skills.disabled || !(Number(skills.value) > 0)) return false;

  return !form.get(`${SimulationConstants.SKILL_PROMPT_PATH}.rubric`)?.value;
}
